// extracted by mini-css-extract-plugin
export default {"container":"SidebarPanelTitle_container__OVupl"};